function playSound(soundName) {
    const audioEl = new Audio(`./${soundName}.mp3`)
    return audioEl.play();
}

const exports = {
    playSound,
}

export default exports;
